import React from "react"
import { User } from "../../../mp-database/types/User"
import { useInitiatedFeedback } from "../../hooks/useInitiatedFeedback"
import FeedbackTray from "./FeedbackTray"

interface Props {
  user: User
  children: (
    showFeedbackItem: boolean,
    openFeedbackTray: () => void
  ) => React.ReactNode
}

const InitiatedFeedbackContainer: React.FC<Props> = ({ user, children }) => {
  const {
    feedbackPrompt,
    openFeedback,
    submitLoading,
    feedbackLoading,
    feedbackTimeoutDisabled,
    onSubmit,
    openFeedbackTray,
    closeFeedbackTray
  } = useInitiatedFeedback()

  const showFeedbackItem =
    user.role === "District Admin" ||
    user.role === "School Admin" ||
    user.role === "Teacher"

  return (
    <>
      {children(showFeedbackItem, openFeedbackTray)}

      {user.role !== "Student" && user.role !== "Instructor" && (
        <FeedbackTray
          user={user}
          open={openFeedback}
          feedbackPrompt={feedbackPrompt}
          submitLoading={submitLoading}
          feedbackLoading={feedbackLoading}
          feedbackTimeoutDisabled={feedbackTimeoutDisabled}
          onSubmit={onSubmit}
          onClose={closeFeedbackTray}
        />
      )}
    </>
  )
}

export default InitiatedFeedbackContainer
